import React from 'react';
import ZoominAppLogo from '../components/ZoominAppLogo';
import { projects } from '../data/projects';
import CourseProjects from './CourseProjects';
import SectionHeader from '../components/styled/SectionHeader';

const Projects = () => {
    return (
        <div className="w-full max-w-6xl mx-auto px-4 pt-2 pb-8 flex flex-col items-center justify-start">
            <SectionHeader
                badgeLabel="Portfolio"
                badgeCount={projects.length}
                badgeUnit="Apps"
                pulseColor="bg-emerald-400"
                title="Featured Applications"
                subtitle="Native Swift & SwiftUI systems built for Apple platforms"
            />

            {/* App Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8 sm:gap-10 md:gap-12 w-full max-w-4xl justify-items-center">
                {projects.map((project, index) => (
                    <ZoominAppLogo
                        key={project.id}
                        index={index}
                        projectId={project.id}
                        imgSrc={project.imgSrc}
                        title={project.title}
                        isPremium={project.isPremium}
                    />
                ))}
            </div>

            <CourseProjects />
        </div>
    );
};

export default Projects;
